import { SxProps, Tooltip, TypographyProps, Theme } from "@mui/material";
import useCopy from "helpers/hooks/useCopy";
import { HTMLAttributes, ReactNode } from "react";
import { P } from "theme/typography";
import { cn } from "./lib/utils";

export function PCopy({
  text,
  pProps,
  sx,
  children,
  className,
}: {
  text: string;
  pProps?: Omit<TypographyProps, "sx">;
  sx?: SxProps<Theme>;
  children: ReactNode;
} & HTMLAttributes<HTMLParagraphElement>) {
  const [isCopied, copy] = useCopy();

  return (
    <Tooltip open={isCopied} title={`"${text}" copied to clipboard`}>
      <P onClick={() => copy(text)} className={cn("cursor-pointer", className)} {...pProps} sx={sx}>
        {children}
      </P>
    </Tooltip>
  );
}
